<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <template>
      <sidebar v-if="menuRefreshId % 2 === 0" id="sidebar-container" class="sidebar-container" />
      <sidebar v-else id="sidebar-container" class="sidebar-container" />
    </template>
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar ref="navbar" />
        <!-- CARGO-31452 去掉H5与flash基础数据维护后刷新缓存提示 -->
        <!-- <tip /> -->
        <tags-view v-if="needTagsView" />
      </div>
      <!--app-main-->
      <app-main id="app-main" @openSysMsg="openSysMsg" />
      <right-panel v-if="false">
        <settings />
      </right-panel>
    </div>
    <cargo-ai-host />
    <el-dialog :visible.sync="isShowingChangePasswordDialog" :title="$t('Message.ChangePassword')" width="420px">
      <el-form label-width="100px" label-position="left" size="mini">
        <el-form-item :label="$t('Message.OriginalPassword')">
          <el-input v-model="oldPassword" type="password" />
        </el-form-item>
        <el-form-item :label="$t('Message.NewPassword')" style="margin-top:16px;">
          <el-input v-model="newPassword" type="password" />
        </el-form-item>
        <el-form-item :label="$t('Message.ConfirmPassword')" style="margin-top:16px;">
          <el-input v-model="newPasswordAgain" type="password" />
        </el-form-item>
        <el-form-item style="margin-top: 16px;display:flex;justify-content: flex-end">
          <el-button type="primary" @click="toChangePassword">{{ $t('Payment.edit') }}</el-button>
          <el-button @click="isShowingChangePasswordDialog=false">{{ $t('Message.Cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import CargoAiHost from '@/components/CargoAi/CargoAiHost.vue'
import { Navbar, Sidebar, AppMain, TagsView, Settings, Tip } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import { changePassword } from '@/api/user'

export default {
  name: 'Layout',
  components: {
    RightPanel,
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    Settings,
    Tip,
    CargoAiHost
  },
  mixins: [ResizeMixin],
  data() {
    return {
      isShowingChangePasswordDialog: false,
      oldPassword: '',
      newPassword: '',
      newPasswordAgain: ''
    }
  },
  beforeCreate() {
    // todo 有时无效
    // console.log('layout index')
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    menuRefreshId() {
      return this.$store.state.permission.menuRefreshId
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    toChangePassword() {
      if (this.oldPassword !== '' && this.newPassword !== '') {
        if (this.newPassword === this.newPasswordAgain) {
          changePassword({ oldPassword: this.oldPassword, newPassword: this.newPassword }).then(res => {
            if (res.ok) {
              this.$message.success(this.$t('Message.ModificationPleaseLogInAgain'))
              this.isShowingChangePasswordDialog = false
              this.$store.dispatch('user/logout').then(() => {
                this.$router.push(`/login?redirect=${this.$route.fullPath}`)
              })
            }
          })
        } else {
          return this.$message.error(this.$t('Message.TheEnteredTwiceAreInconsistent'))
        }
      }
    },
    // 打开铃铛消息界面
    openSysMsg() {
      // 拿到组件的实例 调用打开的方法
      this.$refs.navbar.openSysMsg()
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/element-variables.scss';
  #app .app-main-inner{
    font-size: 12px;
    line-height: 28px;
  }
  #app .app-main-inner .el-dialog__body{
    padding:10px 40px;
  }
  #app .app-main-inner .el-dialog__body .el-form .el-form-item{
    margin-bottom: 8px;
  }
  #app .app-main-inner .el-dialog__body .el-form .el-form-item__content .el-select{
    width: 100%;
  }
  #app .app-main-inner-row{
    display: flex;
    justify-content: space-between;
    padding: 8px 16px 0 16px;
  }
  #app .app-main-inner-row .el-tabs__content{
    padding: 0 15px;
  }
  #app .app-main-inner-row .el-tabs__item{
    height: 29px;
    font-size: 12px;
    line-height: 28px;
  }
  #app .app-main-inner-row .el-tabs{
    background-color: #f5f7fa;
    /*background-color: #f0f2f5;*/
  }
  #app .app-main-inner-row .el-form-item{
    margin-bottom: 3px;
  }
  #app .el-form-item__label{
    font-size: 12px;
    font-weight: normal;
  }
  #app .app-main-inner-row .el-form .el-col{
    margin-top: 10px;
  }
  #app .app-main-inner-row .el-form .el-col .el-form-item-group{
    background-color: #fff;
    padding: 18px;
    box-shadow: 1px 1px 15px rgba(0,0,0,.1)
  }
  /*#app .app-main-inner-row .el-form .el-col .el-form-item-group .el-input__inner{*/
  /*height: 28px;*/
  /*}*/
  #app .app-main-inner-row .el-form .el-col .el-form-item-group .el-date-editor,
  #app .app-main-inner-row .el-form .el-col .el-form-item-group .el-select {
    width:100%;
  }
  #app .app-main-inner-row .el-form .el-col .el-form-item-group .el-form-item__content .el-textarea{
    margin-top: 6px;
    margin-bottom: 2px;
  }
  .edi-wrapper .el-form-item{
    margin-bottom: -9px!important;
  }
  .edi-wrapper .el-form-item .el-input__inner{
    border-radius: 0!important;
  }

  .pinned-top-bar{
    background-color: #fff;
    position:fixed;
    top: 0;
    z-index:1002;
    width: 100%;
  }

  /** Dangerous **/
  .el-message-box__wrapper .el-message-box .el-message-box__btns button:first-child{
    float: right;
    margin-left: 10px;
  }

  #app .el-form-item .el-select--mini{
    width:100%;
  }

  #app .el-form-item-group-card{
    padding: 15px;
    background-color: #fff;
    box-shadow: 1px 1px 15px rgba(0,0,0,.1)
  }

  #app .app-main-inner .button-in-grid-success{
    color: #67c23a;
  }
  #app .app-main-inner .button-in-grid-warning{
    color: #e6a23c;
  }
  #app .app-main-inner .button-in-grid-danger{
    color: #f78989;
  }

  #app .el-form-item:not(.multiple-item-select) .el-input__inner {
    height: 28px!important;
  }
  /** Dangerous **/

  /** el-table start **/
  #app .app-main-inner .el-table .el-table-row-header th {
    font-weight:normal;
    font-size:12px;
    color:black;
    text-align: center;
  }

  #app .app-main-inner .el-table .el-table__header th,
  #app .app-main-inner .el-table .el-table__header tr,
  #app .app-main-inner .el-table .el-table__body tr,
  #app .app-main-inner .el-table .el-table__body td{
    padding: 0;
    height: 25px;
  }
  #app .app-main-inner .el-table .el-table__body .el-table__row td .cell{
    padding: 0;
  }
  /** el-table end **/
  #app .app-main-inner-row .el-form-item__error{
    padding-top: 0px;
    margin-top: -5px;
  }

  /*input content right align*/
  #app .input-content-right input{
    text-align:right;
  }

  #app .el-input-number .el-input input{
    text-align:right
  }

  /*.el-checkbox__label*/
  #app .el-checkbox__label,.el-radio__label{
    font-size:12px;
  }

  /*require item start*/
  /*#app .el-form-item.is-required-after:not(.is-no-asterisk) > .el-form-item__label:after,
  .el-form-item.is-required-after:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
  }*/
  #app .el-form-item.is-required-after > .el-form-item__label:after,
  .el-form-item.is-required-after .el-form-item__label-wrap > .el-form-item__label:after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
  }
  /*require item end*/
</style>
<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";
  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    // width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    // width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    // width: 100%;
  }

  // 中文样式
  #app.zh {
    .fixed-header {
      width: calc(100% - #{$sideBarWidth});
    }
    .hideSidebar .fixed-header {
      width: calc(100% - 54px)
    }

    .mobile .fixed-header {
      width: 100%;
    }
  }

  // 英文样式
  #app.en {
    .fixed-header {
      width: calc(100% - #{$enSideBarWidth});
    }
    .hideSidebar .fixed-header {
      width: calc(100% - 54px)
    }

    .mobile .fixed-header {
      width: 100%;
    }
  }
</style>
